const initialState = {
    loading: null,
    status: null
}

const reducer = (state = initialState, action) => {
    if(action.type ===  'START_LOADING'){
        return {
            loading : true,
            status : null
        }
    }
    if(action.type ===  'STOP_LOADING'){
        return {
            loading : false,
            status : action.status
        }
    }
    return state;
}

export default reducer;